__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@lllverse-dhsn/auth";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@life-line-lab/components-react", "1.0.43", () => (Promise.all([__webpack_require__.e(52), __webpack_require__.e(927), __webpack_require__.e(819)]).then(() => (() => (__webpack_require__(2163))))));
			register("axios", "0.21.1", () => (__webpack_require__.e(644).then(() => (() => (__webpack_require__(9644))))));
			register("crypto-js", "4.1.1", () => (Promise.all([__webpack_require__.e(23), __webpack_require__.e(633)]).then(() => (() => (__webpack_require__(6023))))));
			register("i18next", "20.3.5", () => (__webpack_require__.e(499).then(() => (() => (__webpack_require__(5499))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(927)]).then(() => (() => (__webpack_require__(8316))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(671), __webpack_require__.e(927)]).then(() => (() => (__webpack_require__(8671))))));
			register("react-i18next", "11.11.4", () => (Promise.all([__webpack_require__.e(428), __webpack_require__.e(927)]).then(() => (() => (__webpack_require__(2428))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(817), __webpack_require__.e(927)]).then(() => (() => (__webpack_require__(2817))))));
			register("react", "17.0.2", () => (__webpack_require__.e(784).then(() => (() => (__webpack_require__(2784))))));
			register("recoil", "0.1.3", () => (Promise.all([__webpack_require__.e(732), __webpack_require__.e(927), __webpack_require__.e(819)]).then(() => (() => (__webpack_require__(2732))))));
			register("yup", "0.32.9", () => (Promise.all([__webpack_require__.e(660), __webpack_require__.e(253), __webpack_require__.e(554)]).then(() => (() => (__webpack_require__(8253))))));
			initExternal(6458);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};